<div class="row">
  <div [ngClass]='{ "col-lg-4": isFreemium, "col": !isFreemium }'>
    <div class="app-spoofing info-list height-unset">
      <h3 class="sub-title">
        Spoofing Overview
      </h3>
      <div class="info-list-2">
        <info-list-item label='Apparent Victim of Spoofing'
          labelTooltip='Indicates if the app has a significant amount of impressions detected that may be misrepresented in advertising transactions.'>
          <ng-container #value>
            <ng-container *ngIf="data?.overview?.victimOfSpoofing">
              <img src="/assets/images/icon-indicator-no-2.svg" alt="No Icon" />
            </ng-container>
            <ng-container *ngIf="!data?.overview?.victimOfSpoofing">
              <img src="/assets/images/icon-indicator-yes-2.svg" alt="Yes Icon" />
            </ng-container>

            {{data?.overview?.victimOfSpoofing | yesno:"capitalize"}}
          </ng-container>
        </info-list-item>
        <info-list-item label='Potential Bundle Id Spoofing Risk'
          labelTooltip='The risk the app may be misrepresented in advertising transactions and ads delivered to a different app or site.'>
          <ng-container #value>
            <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
              <risk-heat-meter [risk]='data?.trafficOverview?.appSpoofingRisk'></risk-heat-meter>
            </ng-container>
            <ng-container *ngIf="isFreemium && !isFollowing">
              <div class="value text-capitalize">
                <div class="freemium-lock">
                  <i class="fa fa-lock"></i>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </info-list-item>
      </div>
    </div>
  </div>
  <div class='col-lg-8 px-emphasis ' *ngIf='isFreemium'>
    Pixalate's App Spoofing sections provides traffic where the app identifier does not match app characteristics or the
    app name. Additional data points include:
    <br /><br />
    <ul>
      <li>
        User Agent Obfuscation
      </li>
      <li>
        Device Obfuscation
      </li>
    </ul>
  </div>
</div>

<ng-container *ngIf='!isFreemium'>
  <ng-container *ngFor="let subDataTable of subDataTables">
    <ng-container *ngIf="subDataTable?.data?.length > 0">
      <div class='row mt-5'>
        <div class="col-lg-12">
          <h3 class="sub-title">
            {{subDataTable?.text}}
            <ng-container *ngIf="subDataTable?.tooltip">
              <a [attr.title]="subDataTable?.tooltip">
                <img class="info" src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
              </a>
            </ng-container>
          </h3>
        </div>
      </div>
      <div class="{{subDataTable?.addClass}}">
        <app-data-table-component [headers]="byAppsHeaders | skipcolumn:subDataTable?.addClass"
          [currentSort]="'totalInventoryRatio'" [data]="subDataTable?.data" [limit]="showMoreLimit"
          (itemClick)="goTo($event)" [maxValueMapping]="byOverallMaxValueMapping[subDataTable.key]">
        </app-data-table-component>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf='isFreemium'>
  <app-data-table-component [headers]="byAppsHeaders" [data]="freemiumData"></app-data-table-component>
  <div class='row m-lg-3 mt-3'>
    <div class="col">
      <button class='btn btn-primary btn-schedule-a-demo' (click)='_eventService.openScheduleADemo()'>Schedule a
        Demo!</button>
    </div>
  </div>
</ng-container>

<ng-template #sellerNameTemplate let-item='item' let-row='row'>
  <img src="https://cdn.pixalate.com/sellers/icons/apn/16x16/{{row.sellerId}}.jpg" width="16" height="16" alt="Icon" />
  <span> {{item}}</span>
</ng-template>

<ng-template #declaredBundleIdTemplate let-item='item'>
  <a data-placement="auto" [title]="item">{{ item }}</a>
</ng-template>

<ng-template #detectedBundleIdTemplate let-item='item'>
  <a data-placement="auto" [title]="item">{{ item }}</a>
</ng-template>
